// extracted by mini-css-extract-plugin
module.exports = {"block":"InfoModal_block__143yn","footer":"InfoModal_footer__2Y7RE"};